import { render } from "./IsoAgency.vue?vue&type=template&id=f71782a4&scoped=true"
import script from "./IsoAgency.vue?vue&type=script&lang=js"
export * from "./IsoAgency.vue?vue&type=script&lang=js"

import "./IsoAgency.vue?vue&type=style&index=0&id=f71782a4&scoped=true&lang=css"
import "./IsoAgency.vue?vue&type=style&index=1&id=f71782a4&scoped=true&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f71782a4"]])

export default __exports__